import { resolvePathFromSegments } from '@/support';
import md5 from 'md5';
import { SerializedResource } from '@/types';
import ResourceConfig from '@structure/Configuration/ResourceConfig';
import Directory from './Directory';

export default abstract class AbstractResource {
  protected meta = {};

  constructor(protected readonly resource: SerializedResource) {
    //
  }

  public info(): SerializedResource {
    return this.resource;
  }

  /**
   * Banners and directories have pretty consistent namgin with a project name,
   * sizing info, file extension, etc...
   *
   * This normalizes most filenames into a human-readable format.
   */
  public name(): string {
    const name = this.basename()
      .replace(/\.[^.]+$/, '') // strip the file extension
      .replace(/^.+?_/, '') // strip everything before the first underscore
      .replace(/_+(\d+x\d+)/g, ' ') // remove sizing info
      .replace(/@\dx/g, '') // remove retina marker (@2x, @3x, etc..)
      .replace(/_/g, ' ') // change underscores to spaces
      .replace(/\s+\./g, '.'); // strip spaces appearing before a period

    return name;
  }

  public type(): string {
    return this.info().type;
  }

  public abstract parent(): Directory;

  public path(): string {
    return resolvePathFromSegments(this.info().directory, this.basename());
  }

  public basename(): string {
    return this.info().basename;
  }

  public cid(): string {
    return md5(this.path());
  }

  public setMeta(key: string, value: any): void {
    (this.meta as any)[key] = value;
  }

  public getMeta(key: string, defaultValue: any): any {
    if (key === undefined) {
      return this.meta;
    }

    return Object.prototype.hasOwnProperty.call(this.meta, key)
      ? (this.meta as any)[key]
      : defaultValue;
  }

  public abstract isRoot(): boolean;

  public abstract isDirectory(): boolean;

  public abstract isBanner(): boolean;

  public abstract config(): ResourceConfig;
}
